module.exports = __webpack_public_path__ + "static/media/anc2ru.e00bed68.pdf";